module.exports = __webpack_public_path__ + "img/icon_x.e3ec9e9e.svg";